<script setup lang="ts">
import '../../types/globals';

import {
    nextTick,
    shallowRef,
    unref,
    watch,
} from 'vue';

const props = defineProps<{
    downloadAction?: string;
    downloadParams?: unknown;
    submit?: number;
}>();
const ROOT = __ROOT__;
const form = shallowRef<HTMLFormElement | undefined>();
const params = shallowRef<HTMLInputElement | undefined>();

watch(() => props.submit, () => {
    const _form = unref(form);
    const _params = unref(params);
    if(_form && _params) {
        //if we use vue auto updater with
        //computed(() => JSON.stringify(props.downloadParams));
        //DOM updates only after 3 nextTick in a row
        //so we insert this value manually, to insure it always up to date, before submit
        nextTick(() => {
            //wait for props update
            _form.action = `${ROOT}${props.downloadAction}`;
            _params.value = JSON.stringify(props.downloadParams);
            _form.submit();
        });
    }
});
</script>

<template>
    <Teleport to="#portal-target">
        <form ref="form" method="get" action="" target="_blank">
            <input ref="params" type="hidden" name="params">
        </form>
    </Teleport>
</template>
